/**
 * Component: Policy Modal
 * ------------------------------------------------------------------------------
 * Policy modal for section services column
 *
 * @namespace policyModal
 */
 
import cssClasses from '~/helpers/cssClasses';
import {debounce, on} from '~/helpers/utils';
import Modal from '~/components/modal';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-policy-modal="container"]',
  popupTrigger: '[js-policy-modal="trigger"]',
  modal: '[js-policy-modal="modal"]',
  modalClose: '[js-policy-modal="closeModal"]',
  modalCard: '[js-policy-modal="modalCard"]', 
};


/**
 * Instance settings.
 */
const settings = {
  id: 'policy-modal',
};

/**
 * Create a new cart add-on object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    popupTriggers: document.querySelectorAll(selectors.popupTrigger),
    modal: document.querySelector(selectors.modal),
    modalClose: document.querySelector(selectors.modalClose),
    modalCard: document.querySelector(selectors.modalCard),
  };

  /**
   * Instance globals.
   */
  const modal = Modal({
    id: settings.id,
  });

  /**
   * Initialise component.
   */
  function init() {
    modal.init();
    setEventBusListeners();
    setEventListeners();
  }

  /**
   * Set eventBus listeners.
   */
  function setEventBusListeners() {
    Frame.EventBus.listen(`Modal:Show:${settings.id}`, () => onModalShowCallback());
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    nodeSelectors.popupTriggers.forEach((trigger) => {
      on('click', trigger, (event) => modalShowEvent(event));
    });
    on('click', nodeSelectors.modalClose, () => handleModalCloseEvent());
   }

 
/**
 * Show add-on description.
 * @param {Event} event - click event.
 */
function modalShowEvent(event) {
  event.preventDefault();

  const trigger = event.currentTarget; 
  const link = trigger.getAttribute('data-link'); 
  
  if (link && nodeSelectors.container) {
    // Esegui una richiesta di fetch al link
    fetch(link)
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error('Errore nella richiesta di fetch');
        }
      })
      .then((html) => {
        // Analizza il contenuto HTML ottenuto dalla richiesta
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        // Seleziona l'elemento con l'ID "MainContent"
        const mainContent = doc.getElementById('MainContent');
        if (mainContent) {
          // Inserisci il contenuto nell'elemento con la classe policy-modal__description
          nodeSelectors.container.innerHTML = mainContent.innerHTML;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleModalShowEvent();
}




  /**
   * Handle modal show.
   */
  function handleModalShowEvent() {
    modal.show(settings.id);
  }

  /**
   * Handle modal close.
   */
  function handleModalCloseEvent() {
    modal.close(settings.id);
  }

    function onModalShowCallback() {
   on('click', nodeSelectors.modal, (event) => {

     window.setTimeout(() => {
       if (nodeSelectors.modalCard.contains(event.target)) { return; }
       handleModalCloseEvent();
     }, 300);
   });
 }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
